import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/apiservices'

class StoresComboList extends Component {
    constructor() {
        super()
        this.state = {
            storeComboList: {},
            selectedKitchen:""
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        
       
        this.getStoresCombolList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }


    componentDidUpdate() {


        if (this.props.selectedKitchen!== this.state.selectedKitchen) {
             let selectedKitchen=this.props.selectedKitchen 
             this.setState({
                selectedKitchen:selectedKitchen
                },() => {
                 this.getStoresCombolList()
            });            
        }
    }

    getStoresCombolList = () => {
        apiService.getStoresCombolList(this.state.selectedKitchen)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        storeComboList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.storeComboList).map((value,index) => {
            
            return {
                label : this.state.storeComboList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Store"
                options={list}
                onChange={(e) => { (e) ? this.props.storeChange(e) : this.props.storeChange([])}}
                />
            </div>
        )
    }
}
export default StoresComboList


// WEBPACK FOOTER //
// ./src/modules/Menu Disabled Tickets/Components/DropDowns/StoresComboList.js